import { FeatureFlags } from 'src/app/use-case/feature-flags/utils/feature-flag.models';
import { embededType, forKey } from 'src/app/use-case/type-transformer/type-transformer.use-case';

export class Configuration {
  @forKey('server_version')
  serverVersion: string | undefined;
}

export class GetConfigHttpResponse {
  @forKey('feature_flags')
  @embededType(FeatureFlags)
  featureFlags: FeatureFlags;
  @embededType(Configuration)
  configuration: Configuration;
}

export namespace ConfigEvent {
  export class Success {
    constructor(readonly configuration: Configuration) {}
  }

  export class Loading {}

  export class Error {}
  export class ConnectionError extends Error {}

  export type Spec = Success | Error | Loading;
}
